module.exports = __webpack_public_path__ + "static/media/444SunsetAveNW_2018-06-06_63.13b46a7d.jpg";